import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Sparkle } from "@phosphor-icons/react";

export default function GoogleCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match?.[1];
    if (!session_id) {
      toast.error("Missing Google session");
      navigate("/login");
      return;
    }
    googleLogin(session_id)
      .then(() => {
        toast.success("Signed in with Google");
        navigate("/app");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        navigate("/login");
      });
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Sparkle size={32} weight="duotone" className="mx-auto mb-4 animate-pulse text-[var(--accent)]" />
        <div className="text-[var(--text-2)] text-sm">Signing you in securely…</div>
      </div>
    </div>
  );
}
